import React, { Component } from 'react';
import Modal from '../../ui/modal/Modal';

const styles = {
    tablecellpadding: {
        padding: '1.5em 0'
    }
}

export default class AttachCommunityAnnualReport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showModal: false,
            showAlertModal: false,
            accept: false,
            hideButton: false
        }
    }
    onToggleModal = () => {
        this.setState({
            showModal: this.state.showModal ? false : true
        });
    }
     onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.checked
        })
    }
    onSubmit = (e) => {
        e.preventDefault();
        if(this.props.user.type==='user' && !this.state.accept) {
            this.setState({
                modalText: 'Du skal godkende betingelserne',
                showAlertModal: true,
                showModal: false
            });
        } else {
            this.setState({
                showModal: false,
                hideButton: true
            });
            this.props.onAttachCommunityAnnualReport(this.props.annualReportCommunity);
            this.props.onAttachCommunityAnnualReportHideBtn();
        }
    }
    onHandleDetachAnnualReportCommunity = () => {
        this.setState({
                showModal: false
            });
        this.props.onDetachCommunityAnnualReport(this.props.annualReportCommunity);
    }
    render() {
        if(this.props.currentAnnualReportInherited) {
            return (
                <div>
                    {!this.state.hideButton && this.props.user.type === 'admin' && <button type="button" className="button button--small" onClick={() => this.onToggleModal()}>Fjern tilknytning af årsregnskab og donationer</button>}
                	<Modal visible={this.state.showModal}>
                        <h4>Fjern tilknytning af trossamfundets årsregnskab og donationer</h4>
                        <div style={{marginTop: '1em'}}>
	                        <div style={{marginTop: '1em'}}>
		                        <button type="button" className="button" onClick={() => this.onToggleModal()}>Annuller</button>
		                        <button type="button" className="button" onClick={this.onHandleDetachAnnualReportCommunity}>Bekræft</button>
	                        </div>
                        </div>
                  	</Modal>

                </div>
            )
        } else {
            return (
                <div>
                    {
                    !this.state.hideButton && 
                    !this.props.currentAnnualReport && 
                    !this.props.annualReportFile && 
                    <div>
                        <button type="button" className="button button--small" disabled={(!this.props.donationCommunity || !this.props.annualReportCommunity) && this.props.advancedInterface} onClick={() => this.onToggleModal()}>
                            Tilknyt menighed til trossamfundets konsoliderede årsregnskab og donationer
                        </button>

                        {
                            (!this.props.donationCommunity || !this.props.annualReportCommunity) && 
                            this.props.advancedInterface &&
                            <div className="smallInfoText">
                                Det er ikke muligt at tilknytte menigheden til det konsoliderede årsregnskab og donationer for trossamfundet, da en af delene mangler at blive indberettet.
                            </div>
                        }
                    </div>
                    }
                    
                    <Modal visible={this.state.showModal}>
                        <h4>Tilknytning til trossamfunds årsregnskab og donationer</h4>
                        <div style={{marginTop: '1em'}}>
                            {this.props.annualReportCommunity ? <Checkbox user={this.props.user} onChange={this.onChange} checked={this.state.accept} /> : <div>Det er ikke muligt at tilknytte menigheden til det konsoliderede årsregnskab for trossamfundet, da det endnu ikke er indberettet.</div>}
                            <div style={{marginTop: '1em'}}>
                                <button type="button" className="button" onClick={() => this.onToggleModal()}>Annuller</button>
                                {this.props.annualReportCommunity && <button type="button" className="button" onClick={this.onSubmit}>Gem</button>}
                            </div>
                        </div>
                    </Modal>

                    <Modal visible={this.state.showAlertModal}>
                        <p>{this.state.modalText}</p>
                        <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                            <button type="button" className="button" onClick={() => this.setState({showAlertModal: false, showModal: true})}>Ok</button>
                        </div>
                     </Modal>

                </div>
            )
        }
    }
}

const Checkbox = (props) => {
    if(props.user.type==='admin') {
        return (
            <div>Der foreligger dokumentation i ESDH-systemet for, at trossamfundet/menigheden har anmodet By-, Land- og Kirkeministeriet om at indberette på trossamfundets/menighedens vegne.</div>
        )
    } else {
        return (
            <label style={{fontSize: '1em', padding: 0, margin: 0}}>
                <input type="checkbox" name="accept" onChange={props.onChange} checked={props.checked} />
                    Jeg erklærer hermed på tro og love, at menighedens årsregnskab og oplysninger om donationer fremgår af det konsoliderede årsregnskab for trossamfundet.
            </label>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/reports/AttachCommunityAnnualReport.js